/**
 * This module contains the common functions
 * used by the instructions
 */

(function() {

  const $ = require('jQuery');
  const icons = require('../../icons');
  const tooltips = require('../machinelogic_tooltips');
  const widgets = require('../widgets');

  /**
   * Build the instruction card
   * @param {jQuery} pCard - a jQuery object represeting the _lCard
   * @param {Object} pInstruction - Instruction Object
   * @param {jQuery} pActions - a jQuery object represeting the _lActions
   * @returns this function does not return anything
   */
  function buildInstruction(pParameterWidget) {
    return function(pCard, pInstruction, pActions, pFilteredActionsSet) {
      // Detach the children and build again the instruction parameters
      pCard.parameters.children().trigger("vention_detach");
      pCard.parameters.children().detach();
      // Build any other instruction (wait, trigger, output)
      pCard.parameters.append(pActions);
      pCard.parameters.css({ 'max-width': '93%' });
      pFilteredActionsSet[pInstruction.getName()].parameters.forEach(function (pParamInfo) {
        pInstruction.listParameters().forEach(function (pParam) {
          if (pParamInfo.name == pParam) {
            pParameterWidget(pParamInfo, pParam);
          }
        });
      });
      // Show tooltip icon beside instruction label
      const tooltipInstructionMatch = pInstruction
        .getName()
        .match(/combined/i) != null
        ? pInstruction.getName().replace(/combined/i, '')
        : pInstruction.getName();
      if (tooltips.keys[tooltipInstructionMatch]) {
        pActions.setLabelIcon(
          $('<div class="ml_tooltip_icon ' + icons.unknown + '"/>').click(
            function () {
              tooltips.showTips(tooltipInstructionMatch);
            }
          )
        );
      } else {
        pActions.detachLabelIcon();
      }
    };
  }

  /**
   * Get the not deprecated instructions set
   *
   * @param {Object} pLibrary - Library Object
   * @param {Object} pInstruction = Instruction Object
   * @returns {Object} available instructions
   */
  function getActions(pLibrary, pInstruction) {
    const lCategory = pInstruction.getCategory();
    return pLibrary._getNotDeprecatedActionSet(lCategory);
  }

  /**
   * Construct an array with value and text
   * from the object keys
   *
   * @param {Object} pActionList
   * @returns { { value: string, text: string } }
   */
  function getActionList(pActionList) {
    return Object.keys(pActionList).reduce(function (acc, curr) {
      if (pActionList[curr].uiProps && pActionList[curr].uiProps.displayName) {
        acc.push({ value: curr, text: widgets.camelCaseToText(pActionList[curr].uiProps.displayName) });
      } else {
        acc.push({ value: curr, text: widgets.camelCaseToText(curr) });
      }
      return acc;
    }, []);
  }

  /**
   * Get Instruction listeners
   *
   * @param {Object} pParams
   * @param {Function} pParams.buildInstruction - function to build the instruction parameters
   * @param {jQuery} pParams.actions - jQuery widget representing instructions
   * @param {jQuery} pParams.card - jQuery widget representing the instruction card
   * @param {Array} pParams.filteredActionsSet - list of available actions
   * @param {ml.Instruction} pParams.instruction - Instruction machine logic object
   * @param {ml.Library} pParams.library - Library machine logic object
   * @param {Object} pParams.parameterMap - Parameter map object
   * @returns { { onNameChanged: Function, onParameterChanged: Function } }
   */
  function getInstructionListener(pParams) {
    const buildInstruction = pParams.buildInstruction;
    const lActions = pParams.actions;
    const lCard = pParams.card;
    const lFilteredActionsSet = pParams.filteredActionsSet;
    const lInstruction = pParams.instruction;
    const lParameterMap = pParams.parameterMap;

    return {
      onNameChanged: function(pName) {
        Object.keys(lParameterMap).forEach(function(pKey) {
          delete lParameterMap[pKey];
        });
        lActions.setValue(pName);
        lCard.parameters.removeClass('one_param two_param three_param'); // Reset style of array
        buildInstruction(lCard, lInstruction, lActions, lFilteredActionsSet);
      },
      onParameterChanged: function(pName, pValue) {
        // Note (alevy): used only for undo inCAD
        if (lParameterMap.hasOwnProperty(pName)) {
          lParameterMap[pName].find('input, select').val(pValue);

          if (pName == 'inputUuid' || pName == 'outputUuid') {
            buildInstruction(lCard, lInstruction, lActions, lFilteredActionsSet);
          }
        }
      }
    };
  }

  /**
   * Rename some categories to present
   * differently in the UI
   *
   * @param {String} pCategory - The category name
   * @returns {String} the category name to be used in the UI
   */
  function replaceCategory(pCategory) {
    switch (pCategory) {
      case 'motor':
        return 'motion';
      case 'trigger':
        return 'execution';
      default:
        return pCategory;
    }
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    buildInstruction: buildInstruction,
    getActions: getActions,
    getActionList: getActionList,
    getInstructionListener: getInstructionListener,
    replaceCategory: replaceCategory,
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
})();
